/* eslint-disable react/destructuring-assignment */
/* eslint-disable camelcase */
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import './VMNManagement.css';
import {
  sess_post,
} from '../../../utils/HttpRequests';

const UpdateCategoryPrice = (props) => {
  const [detail, setDetail] = useState({ category: '', price: 0 });
  const { getAllPrices } = props;
  const [error, setError] = useState('');

  const onChange = (e) => {
    e.preventDefault();
    setDetail({ ...detail, [e.target.id]: e.target.value });
  };

  const updateCategoryPrice = async () => {
    try {
      if (!detail.category) {
        setError('Select category');
        return;
      }
      if (!detail.price) {
        setError('Price is required');
        return;
      }
      const sessionToken = localStorage.getItem('admin-panel-sessionToken');
      const params = {
        category: detail.category,
        price: Math.max(0, detail.price),
      };
      await sess_post('admin/console/update-vmns-price-by-category', sessionToken, params);
      setError('');
      setDetail({ ...detail, category: '', price: 0 });
      getAllPrices();
    } catch (err) {
      setError(err?.response?.data?.error?.reason || err.message || 'something went wrong in update category price');
    }
  };
  return (
    <div style={{ textAlign: 'left', fontWeight: 'bolder' }}>
      <form className="form-horizontal">
        <div className="container">
          <div className="label">Update Category Price</div>
          <div className="inputs-fl-1">
            <select className="form-control" onChange={onChange} id="category" value={detail.category}>
              <option value="" selected="selected">Select VMN category</option>
              <option value="similar">Similar</option>
              <option value="premium">Premium</option>
              <option value="vip">VIP</option>
            </select>
          </div>
          <div className="inputs-fl-1">
            <input className="form-control" type="number" id="price" value={detail.price} onChange={onChange} />
            <span style={{ color: 'green' }}>
              **Price in rupees
            </span>
          </div>
          <div className="inputs-fl-1">
            <Button variant="danger" onClick={updateCategoryPrice}>Update Price</Button>
          </div>
          <div className="inputs-fl-1">
            <ul>
              <li>
                Premium: ₹
                {props.detail.premium_price / 100}
              </li>
              <li>
                Similar: ₹
                {props.detail.similar_price / 100}
              </li>
              <li>
                VIP: ₹
                {props.detail.vip_price / 100}
              </li>
            </ul>
          </div>
          {error && <div className="label" style={{ color: 'red' }}>{error}</div>}
        </div>
      </form>
    </div>
  );
};
export default UpdateCategoryPrice;
